import {HttpClient, HttpClientModule} from '@angular/common/http';
import {Inject, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {JwtModule} from '@auth0/angular-jwt';
import {NgbDateAdapter, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgRestModelConfig, NgRestModelModule} from 'ng-rest-model';
import {environment} from '../environments/environment';
import {ContentsService} from './administration/contents/contents.service';
import {UserService} from './administration/users/user.service';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AuthModule} from './auth/auth.module';
import {Auth} from './auth/auth.service';
import {ContentsModule} from './contents/contents.module';
import {EmailModule} from './email/email.module';
import {Error404Component} from './error-404/error-404.component';
import {FooterComponent} from './footer/footer.component';
import {FriendsComponent} from './friends/friends.component';
import {HomeComponent} from './home/home.component';
import {HomeService} from './home/home.service';
import {MainMenuComponent} from './main-menu/main-menu.component';
import {SermonsModule} from './sermons/sermons.module';
import {BreadcrumbsService} from './shared/components/breadcrumbs/breadcrumbs.service';
import {NgbDateStringAdapter} from './shared/services/ngb-date-string-adapter.service';
import {SharedModule} from './shared/shared.module';
import {WhatWeDoModule} from './what-we-do/what-we-do.module';
import {WhoWeAreModule} from './who-we-are/who-we-are.module';
import {SchedulesService} from './worship/schedules/schedules.service';
import {InstrumentService} from './worship/team/instruments/instrument.service';
import {MemberService} from './worship/team/members/member.service';
import { NotPermittedComponent } from './not-permitted/not-permitted.component';
import { registerLocaleData } from '@angular/common';
import localeHu from '@angular/common/locales/hu';
import localeHuExt from '@angular/common/locales/extra/hu';

registerLocaleData(localeHu, 'hu', localeHuExt);

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        Error404Component,
        MainMenuComponent,
        FriendsComponent,
        FooterComponent,
        NotPermittedComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        JwtModule.forRoot(Auth.JWT_CONFIG),
        SharedModule.forRoot(),
        NgbModule.forRoot(),
        NgRestModelModule,

        AuthModule,
        SermonsModule,
        WhoWeAreModule,
        WhatWeDoModule,
        ContentsModule,
        EmailModule,

        AppRoutingModule
    ],
    providers: [
        BreadcrumbsService,
        HomeService,
        {provide: NgbDateAdapter, useClass: NgbDateStringAdapter},

        // providing feature services due to missing JwtModule.forChild()
        // worship
        InstrumentService,
        MemberService,
        SchedulesService,
        // administration
        ContentsService,
        UserService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(
        @Inject(NgRestModelConfig) config: NgRestModelConfig,
        @Inject(HttpClient) http: HttpClient
    ) {
        config.configure({
            baseUrl: environment.api,
            http: http
        });
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/app.module.ts